/**
 * Parses custom field attribute value to ensure it's correctly composed, e.g.
 * sometimes backend would return some string set values in an incorrect order
 * which need to be sorted to work properly on frontend.
 *
 * @param attribute The attribute schema.
 * @param value The attribute value.
 */
export function parseCustomFieldAttributeValue(attribute, value) {
    if (!value)
        return value;
    switch (attribute.type) {
        case 'select':
            return getSortedHierarchicalValue(attribute, value);
        default:
            return value;
    }
}
/**
 * Sorts string set value by hierarchy as defined by the attribute options.
 *
 * @param attribute The select attribute schema.
 * @param value The string set attribute value.
 */
function getSortedHierarchicalValue(attribute, value) {
    const sortedValue = [];
    const walkOptions = (options) => {
        const foundOption = options.find((option) => value.value.includes(option.value));
        if (foundOption) {
            sortedValue.push(foundOption.value);
            if (foundOption.options) {
                walkOptions(foundOption.options);
            }
        }
    };
    walkOptions(attribute.options);
    return Object.assign(Object.assign({}, value), { value: sortedValue });
}
